import { REDISPUTE_REVIEW_PREVIOUS_QUESTION_ID } from '../../const/questionIds';
import { QuestionnaireFlow } from './typings';
var endOfFlow = ['END OF FLOW', 'END_OF_FLOW'];
var END_OF_FLOW_EXIT = 'END_OF_FLOW_EXIT';
var END_OF_FLOW_FRAUD = 'END_OF_FLOW_FRAUD_PAGE';
var END_OF_FLOW_DOUBLECHARGE = 'END_OF_FLOW_DOUBLECHARGE';
export var determineNextStep = function (nextQuestionId, currentQuestionId) {
    if (endOfFlow.includes(nextQuestionId.toUpperCase()) &&
        currentQuestionId === REDISPUTE_REVIEW_PREVIOUS_QUESTION_ID) {
        return QuestionnaireFlow.RedisputeReview;
    }
    if (endOfFlow.includes(nextQuestionId.toUpperCase())) {
        return QuestionnaireFlow.Review;
    }
    if (nextQuestionId === END_OF_FLOW_EXIT) {
        return QuestionnaireFlow.Exit;
    }
    if (nextQuestionId === END_OF_FLOW_FRAUD) {
        return QuestionnaireFlow.ContactFraud;
    }
    if (nextQuestionId === END_OF_FLOW_DOUBLECHARGE) {
        return QuestionnaireFlow.CantIdentifyDup;
    }
    return undefined;
};
export var determineCurrentStep = function (previousStep, previousQuestion, previousAnswer, accountCredits) {
    if (previousStep === QuestionnaireFlow.Review ||
        previousStep === QuestionnaireFlow.RedisputeReview) {
        return QuestionnaireFlow.InProgress;
    }
    if (previousStep === QuestionnaireFlow.ContactFraud &&
        (previousAnswer === null || previousAnswer === void 0 ? void 0 : previousAnswer.nextQuestionId) === END_OF_FLOW_FRAUD) {
        return QuestionnaireFlow.InProgress;
    }
    if (previousStep === QuestionnaireFlow.InProgress && !previousQuestion) {
        return accountCredits.length
            ? QuestionnaireFlow.CreditDetails
            : QuestionnaireFlow.Start;
    }
    return undefined;
};
//# sourceMappingURL=helpers.js.map